import { Theme } from "@mui/material";

export const rpeToColor = (theme: Theme, rpe: number) => {
  const {
    palette: { rpeLight, rpeModerate, rpeHeavy },
  } = theme;
  return rpe <= 3 ? rpeLight.main : rpe <= 7 ? rpeModerate.main : rpeHeavy.main;
};
